import { bus } from "@/main";
import { getMenuEntry } from "@/data/models/menu.model";
import { setInterval } from "timers";

export default {
	data() {
		return{
		
		}
	},
	props: [
		"title",
		"date",
		"source",
	],
	created() {
	},
	mounted() {
		this.animateDiv();
	},
	methods: {
		animateDiv() {
			let boxes = this.$el.children;
			
			setInterval(function () { 
				for (let i = 0; i < boxes.length; i++) {
					const box = boxes[i];
					let random = Math.floor(Math.random() * (3 - 1)) + 1
					
					box.style.width = random + 'rem'
				}
			}, 400);
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/blocks/loading-block/loading.block.js